import React from "react";
import styles from "./Humans.module.scss";
import cx from "classnames";
import Item from "./Item";
import { usePageContext } from "@providers/PageProvider";
import { careerPage } from "@utils/helper";
import _ from "lodash";

export default function Humans() {
  const { pageData } = usePageContext();
  const humans = careerPage.formatHumans(pageData);

  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center mx-auto", styles.section)}
    >
      <div className={cx(styles.title)}>{_.get(humans, "title")}</div>
      <div className={cx(styles.description)}>
        {_.get(humans, "description")}
      </div>
      <div className={cx(styles.itemWrapper)}>
        {_.map(
          _.slice(_.get(humans, "articles", []), 0, 2),
          (item: any, index) => (
            <Item key={index} data={item} />
          )
        )}
      </div>
    </div>
  );
}
